<div class="container-fluid">
  <h4 id="upper">Transaction Market-place (Retrait)</h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <!-- Barre de filtres -->
          <div class="row mb-3">
            <div class="col-md-12">
              <div class="d-flex align-items-center gap-3 flex-wrap">
                <!-- Recherche -->
                <div class="flex-grow-1" style="min-width: 200px;">
                  <label class="form-label mb-0">Rechercher</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="mdi mdi-magnify"></i></span>
                    <input title="Rechercher par référence, vendeur, téléphone ou montant" type="text"
                      [(ngModel)]="searchTerm" (input)="filterBySearchTerm()" class="form-control" id="searchMembre"
                      placeholder="Rechercher..." />
                    <button class="btn btn-outline-secondary" (click)="searchTerm = ''; filterBySearchTerm()"
                      type="button" *ngIf="searchTerm">
                      <i class="mdi mdi-close"></i>
                    </button>
                  </div>
                </div>

                <!-- Filtre par statut -->
                <div style="min-width: 200px;">
                  <label class="form-label mb-0">Statut</label>
                  <select class="form-select" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
                    <option *ngFor="let option of statusOptions" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                <!-- Ajoutez dans la barre de filtres -->
                <div style="min-width: 200px;">
                  <label class="form-label mb-0">Date début</label>
                  <input type="date" class="form-control" [(ngModel)]="dateDebut" (change)="applyFilters()" />
                </div>
                <div style="min-width: 200px;">
                  <label class="form-label mb-0">Date fin</label>
                  <input type="date" class="form-control" [(ngModel)]="dateFin" (change)="applyFilters()" />
                </div>

                <!-- Statistiques rapides -->
                <div class="d-flex gap-2 flex-wrap" style="margin-top: 22px;">
                  <span class="badge bg-secondary p-2">
                    Total: {{ items.length }}
                  </span>
                  <span class="badge bg-success p-2">
                    <i class="mdi mdi-check-circle"></i>
                    Complété: {{ getStatusCount('completed') }}
                  </span>
                  <span class="badge bg-danger p-2">
                    <i class="mdi mdi-close-circle"></i>
                    Échoué: {{ getStatusCount('failed') }}
                  </span>
                  <span class="badge bg-warning p-2">
                    <i class="mdi mdi-clock"></i>
                    En attente: {{ getStatusCount('pending') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tableau -->
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                  style="border-color: #578D63;">
                  <th scope="col">Référence</th>
                  <th scope="col">Vendeur</th>
                  <th scope="col">Téléphone</th>
                  <th scope="col">Montant</th>
                  <th scope="col">Statut</th>
                  <th scope="col">Date</th>
                  <th scope="col" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr *ngFor="let item of paginatedItems">
                  <td>
                    <span class="table-link1 text-truncate d-block" title="{{ item?.reference }}">
                      {{ item?.reference }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block">
                      {{ item?.vendeur?.prenom }} {{ item?.vendeur?.nom }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block">
                      {{ item?.phone_number || item?.vendeur?.telephone || '-' }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block fw-bold">
                      {{ item?.montant }} FCFA
                    </span>
                  </td>
                  <td>
                    <span class="badge {{ getStatusBadge(item?.statut) }}" style="font-size: 12px; padding: 6px 12px;">
                      <i class="mdi" [class.mdi-check-circle]="item?.statut === 'completed'"
                        [class.mdi-close-circle]="item?.statut === 'failed'"
                        [class.mdi-clock]="item?.statut === 'pending'" [class.mdi-sync]="item?.statut === 'processing'"
                        me-1>
                      </i>
                      {{ getStatusLabel(item?.statut) }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block" style="font-size: 12px;">
                      {{ formatDate(item?.created_at) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <a (click)="openDetailModal(item)" style="cursor: pointer;" class="me-2 text-info" v-b-tooltip.hover
                      title="Voir les détails">
                      <i class="mdi mdi-eye font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Message si aucun résultat -->
          <div *ngIf="paginatedItems.length === 0 && !isLoading" class="text-center py-4">
            <i class="mdi mdi-inbox-outline" style="font-size: 48px; color: #ccc;"></i>
            <h5 class="text-muted">Aucune transaction trouvée</h5>
            <p class="text-muted" *ngIf="selectedStatus || searchTerm">
              Aucun résultat ne correspond à vos critères de recherche.
              <a (click)="resetFilters()" style="cursor: pointer; color: #578D63;">
                Réinitialiser les filtres
              </a>
            </p>
          </div>

          <!-- Chargement -->
          <div class="d-flex justify-content-center" *ngIf="isLoading === true">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Chargement en cours...</h5>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Détails -->
<ng-template #detailModal let-modal>
  <div class="modal-header" style="background-color: #578D63; color: white;">
    <h5 class="modal-title text-white">
      <i class="mdi mdi-receipt-text me-2"></i>
      Détails de la transaction
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body" *ngIf="selectedItem">
    <!-- En-tête de la transaction -->
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-subtitle mb-2 text-muted">Informations générales</h6>
            <p class="mb-1"><strong>Référence :</strong> {{ selectedItem.reference }}</p>
            <p class="mb-1"><strong>Montant :</strong> <span class="fw-bold text-success">{{ selectedItem.montant }}
                FCFA</span></p>
            <p class="mb-1">
              <strong>Statut :</strong>
              <span class="badge {{ getStatusBadge(selectedItem.statut) }}">
                {{ selectedItem.statut }}
              </span>
            </p>
            <p class="mb-0"><strong>Date de création :</strong> {{ formatDate(selectedItem.created_at) }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-subtitle mb-2 text-muted">Informations vendeur</h6>
            <p class="mb-1"><strong>Nom :</strong> {{ selectedItem.vendeur?.prenom }} {{ selectedItem.vendeur?.nom }}
            </p>
            <p class="mb-1"><strong>Téléphone :</strong> {{ selectedItem.vendeur?.telephone }}</p>
            <p class="mb-0"><strong>Référence :</strong> {{ selectedItem.vendeur?.reference }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Détails du paiement -->
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header bg-info text-white">
            <h6 class="mb-0">Détails du paiement</h6>
          </div>
          <div class="card-body">
            <p class="mb-1"><strong>Mode de paiement :</strong> {{ selectedItem.mode_paiement || 'Non spécifié' }}</p>
            <p class="mb-1"><strong>Référence FeexPay :</strong> {{ selectedItem.feexpay_reference || 'Non disponible'
              }}</p>
            <p class="mb-0" *ngIf="selectedItem.motif_echec">
              <strong>Motif d'échec :</strong>
              <span class="text-danger">{{ selectedItem.motif_echec }}</span>
            </p>
            <p class="mb-0" *ngIf="selectedItem.phone_number">
              <strong>Numéro du bénéficiaire :</strong> {{ selectedItem.phone_number }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header bg-warning">
            <h6 class="mb-0">Portefeuille</h6>
          </div>
          <div class="card-body">
            <p class="mb-1"><strong>Solde disponible :</strong> {{ selectedItem.wallet?.solde_disponible_actuel || 0 }}
              FCFA</p>
            <p class="mb-0"><strong>Solde en attente :</strong> {{ selectedItem.wallet?.solde_en_attente_actuel || 0 }}
              FCFA</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Items couverts -->
    <div class="card" *ngIf="selectedItem.items_couverts && selectedItem.items_couverts.length > 0">
      <div class="card-header bg-primary text-white">
        <h6 class="mb-0">Produits couverts</h6>
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Produit</th>
                <th>Quantité</th>
                <th class="text-end">Montant</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of selectedItem.items_couverts; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.produit }}</td>
                <td>{{ item.quantite }}</td>
                <td class="text-end">{{ item.montant }} FCFA</td>
              </tr>
              <tr class="table-active">
                <td colspan="3" class="text-end fw-bold">Total :</td>
                <td class="text-end fw-bold">{{ getTotalItemsMontant(selectedItem.items_couverts) }} FCFA</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">
      <i class="mdi mdi-close me-1"></i> Fermer
    </button>
    <button type="button" class="btn btn-primary" (click)="modal.close('Close click')">
      <i class="mdi mdi-check me-1"></i> OK
    </button>
  </div>
</ng-template>

<p-toast />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>